// extracted by mini-css-extract-plugin
module.exports = {"card":"AddressCard_card__1A2hb","nameContainer":"AddressCard_nameContainer__3jVFI","fullName":"AddressCard_fullName__1gWi-"};